import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './store';
import { setFilter, clearFilter, clearAllFilters } from './advancedSearchReducer';

/**
 * Hook to get the saved SCIM filter for a specific entity type
 */
export const useAdvancedSearchFilter = (entityType: string): string | undefined => {
    return useSelector((state: RootState) => {
        const normalizedType = entityType?.toLowerCase() || '';
        return state.advancedSearch?.filters[normalizedType];
    });
};

/**
 * Hook to get all saved filters
 */
export const useAdvancedSearchFilters = (): Record<string, string> => {
    return useSelector((state: RootState) => state.advancedSearch?.filters || {});
};

/**
 * Hook to get actions for managing advanced search filters
 */
export const useAdvancedSearchActions = () => {
    const dispatch = useDispatch();

    return {
        setFilter: (entityType: string, filter: string) => {
            dispatch(setFilter({ entityType, filter }));
        },
        clearFilter: (entityType: string) => {
            dispatch(clearFilter(entityType));
        },
        clearAllFilters: () => {
            dispatch(clearAllFilters());
        }
    };
};

